// External Dependencies:
import axios from 'axios'

export function doRequest( url, options = {} ) {
	return axios( {
			url: url,
			timeout: 600 * 1000,
			responseType: 'json',
			...options
		} )
		.then( function( response ) {
			return response.data
		} )
		.catch( function( error ) {
			return Promise.reject( error.response )
		} )
}
